import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import {userService} from '../services/userService'
import ACLService from '../services/aclService';

interface PrivateRouteProps {
    component: any,
    exact: boolean,
    redirectTo?: string,
    path: string,
    moduleName?: string,
    type?: string
}
const PrivateRoute = ({ component, redirectTo="/", moduleName, type , ...rest }: PrivateRouteProps) => {
    if (!userService.isAuthenticated()) {
        return <Redirect to={redirectTo} />
    }
    return <Route {...rest} component={permissionCheck(component, moduleName, type)} />
}

function permissionCheck(WrappedComponent: any, moduleName?: any, type?: any) {
    return function(...props: any[]) {
        if (moduleName && userService.isAuthenticated()) {
            if (!ACLService.checkModulePermission(moduleName, type)) {
                return  <Redirect to="/accessDenied" />
            }
        }
        return <WrappedComponent {...props[0]} />

    }
}

const mapStateToProps = (state: any) => ({
    userData: state.loginData.userData
});

//@ts-ignore
export default PrivateRoute;